
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class IvrgatewayService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
    }

    list(query?: any) {
        return this.get('/ivrgateways',query);
    }

    create(body: any) {
        return this.post('/ivrgateway',body);
    }

    find(id) {
        return this.get('/ivrgateway/'+id);
    }

    update(id, body) {
        return this.put('/ivrgateway/'+id, body);
    }

    allIvrgateway(query?: any) {
        return this.get('/all-ivrgateway', query);
    }

    _delete(id) {
        return this.delete('/ivrgateway/'+id);
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/Ivrgateway.service.ts